import i18next from 'i18next';

export const INTEGRATION_COMMON_NAMESPACE = 'integration';

export async function initCommonTranslations(locale = 'en') {
  const { default: resources } = await import(`./lang/${locale}.json`);
  i18next.addResourceBundle(locale, INTEGRATION_COMMON_NAMESPACE, resources);
}
